export default{
  blocks: (state) => state.blocks,
  block: (state) => state.block
}



// WEBPACK FOOTER //
// ./src/components/block/store/getters.js